import Api from '@/services/Api'
import router from '@/router/index.js'
import store from '@/store/index.js'

function handle(path, data){
  console.log("calling method : "+path+'/'+data.method)
  return new Promise(function(resolve, reject){
    Api().post(path, data)
    .then(function(response){
        if(response.data.ok){
          resolve(response.data.result)
        }else{
          reject(response.data)
        }
      })
    .catch(function(error){
      console.log('Error :', error.toJSON());
      if (error.response) {
        reject(error.response.data)
        if(error.response.status == 401){
          store.dispatch('logout')
          if (router.app.$route.path !== '/login')
              router.push({ path: '/login' })
        }
      }else{
        reject({"ok": false, "status": null, "description": error.message})
      }
    })
  })
}

export default{
  //User methods
  createUser(user){
    let data = {user: user, method: 'create', data: {}}
    return handle('/user', data)
  },
  getUser(user){
    let data = {user: user, method: 'get', data: {}}
    return handle('/user', data)
  },
  updateUser(user, bots){
    let data = {user: user, method: 'update', data: {bots: bots}}
    return handle('/user', data)
  },
  deleteUser(user){
    let data = {user: user, method: 'delete', data: {}}
    return handle('/user', data)
  },

  //Bot methods
  createBot(user, token, structure){
    let data = {user: user, method: 'create', data: {id: user.id, token: token, structure: structure}}
    return handle('/bot', data)
  },
  getBot(user, token){
    let data = {user: user, method: 'get', data: {token: token}}
    return handle('/bot', data)
  },
  updateBot(user, token, structure){
    let data = {user: user, method: 'update', data: {token: token, structure: structure}}
    return handle('/bot', data)
  },

  updateBotAdmins(user, token, admins){
    let data = {user: user, method: 'update_admins', data: {token: token, admins: admins}}
    return handle('/bot', data)
  },

  updateBotPrimeMembers(user, token, prime_members){
    let data = {user: user, method: 'update_prime_members', data: {token: token, prime_members: prime_members}}
    return handle('/bot', data)
  },

  deleteBot(user, token){
    let data = {user: user, method: 'delete', data: {id: user.id, token: token}}
    return handle('/bot', data)
  },

  updateBotStatus(user, token, status){
    let data = {user: user, method: 'update_status', data: {status: status, token: token}}
    return handle('/bot', data)
  },

  updateBotSettings(user, token, settings){
    let data = {user: user, method: 'update_settings', data: {settings: settings, token: token}}
    return handle('/bot', data)
  },

  updateBotAllowGroup(user, token, allow_group){
    let data = {user: user, method: 'update_allow_group', data: {allow_group: allow_group, token: token}}
    return handle('/bot', data)
  },

  updateBotDebug(user, token, debug){
    let data = {user: user, method: 'update_debug', data: {debug: debug, token: token}}
    return handle('/bot', data)
  },

  getSubscribers(user, token, lastEvalKey=null){
    let data = {user: user, method: 'get', data: {token: token, last_eval_key: lastEvalKey}}
    return handle('/subscribers', data)
  },

  resetReferralCount(user, token, user_id){
    let data = {user: user, method: 'reset_referrals', data: {token: token, user_id: user_id}}
    return handle('/bot', data)
  },

  //general methods
  getCompanyStats(){
    let data = {method: 'get_company_stats', data: {}}
    return handle('/general', data)
  },
  getBots(){
    let data = {method: 'get_all_bots', data: {}}
    return handle('/general', data)
  }
  
  
}
